import { Store } from "pullstate";
var BulkCsvUploadStore = new Store({
  view: "idle",
  viewData: {
    workspace: null
  }
});
function reducer(action) {
  if (action.type === "show-modal") {
    BulkCsvUploadStore.update(function (s) {
      s.view = "visible";
      s.viewData.workspace = action.payload.workspace;
    });
  } else if (action.type === "upload") {
    console.log(action.payload);

    // make an api call here

    // upon completion, hide the modal
    reducer({
      type: "hide-modal"
    });
  } else if (action.type === "hide-modal") {
    BulkCsvUploadStore.update(function (s) {
      s.view = "idle";
      s.viewData.workspace = null;
    });
  }
}
function useBulkCsvUpload() {
  var state = BulkCsvUploadStore.useState(function (s) {
    return s;
  });
  return [state, reducer];
}
export default useBulkCsvUpload;